"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonControlsText = exports.Button = exports.AwliWidget = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.ApplyWithButtons = void 0;
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var AwliWidget_1 = require("../AwliWidget/AwliWidget");
Object.defineProperty(exports, "AwliWidget", { enumerable: true, get: function () { return AwliWidget_1.AwliWidget; } });
var player_button_1 = require("player-button");
exports.Button = player_button_1.default;
var Text_1 = require("player-common-controls/controls/Text");
Object.defineProperty(exports, "CommonControlsText", { enumerable: true, get: function () { return Text_1.Text; } });
var ApplyWithButtons = (function (_super) {
    __extends(ApplyWithButtons, _super);
    function ApplyWithButtons(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign(__assign({}, _this.view.state), _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplyWithButtons.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign(__assign({}, _this.view.state), _this.props)
                });
            })
            : null;
    };
    ApplyWithButtons.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    ApplyWithButtons.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    ApplyWithButtons.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign(__assign(__assign({}, this.state.viewModel), this.view.state), this.props)
        }, cb ? cb : function () { });
    };
    ApplyWithButtons.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign(__assign(__assign({}, viewModel), viewState), props) });
    };
    ApplyWithButtons.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    ApplyWithButtons.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    ApplyWithButtons.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplyWithButtons.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            var service_handler = function () {
                var service_result = $this.state.viewModel.applyWithServices.map(function (service, service$index) {
                    $this.state.viewModel.service = service;
                    $this.state.viewModel.service$index = service$index;
                    return [React.createElement(GridCol_1.GridCol, { key: service$index.toString() + 0, width: "12", children: [React.createElement(GridLayout_1.GridLayout, { key: service$index.toString() + 0, gutterHorizontal: "Xsmall", gutterVertical: "Xsmall", columnDirection: "Row", children: [React.createElement(GridCol_1.GridCol, { key: service$index.toString() + 0, width: "12", widthForSm: "6", offsetRightForSm: "6", widthForMd: "4", offsetRightForMd: "8", children: [React.createElement(player_button_1.default, { key: service$index.toString() + 0, color: $this.state.viewModel.service.extras.color, iconName: $this.state.viewModel.service.extras.iconName, tag: $this.state.viewModel.service.extras.tag, text: $this.state.viewModel.service.extras.buttonText, toolTip: $this.state.viewModel.service.extras.buttonText, width: "Block", onClick: _this._proxyEvent("onClick", service, service$index, "repeaterArgs") })] }), React.createElement(GridCol_1.GridCol, { key: service$index.toString() + 1, width: "12", isVisible: $this.state.viewModel.service.extras.warningMessageVisible, children: [React.createElement(Text_1.Text, { key: service$index.toString() + 0, wrapMode: "None", size: "Small", color: $this.state.viewModel.service.extras.warningColor, text: $this.state.viewModel.service.extras.warningMessage, tag: $this.state.viewModel.service.extras.warningTag })] })] })] })];
                });
                delete $this.state.viewModel.service;
                delete $this.state.viewModel.service$index;
                return service_result;
            };
            return [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Xsmall", gutterVertical: "Xsmall", columnDirection: "Row", children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "12", widthForSm: "6", offsetRightForSm: "6", widthForMd: "4", offsetRightForMd: "8", children: [React.createElement(AwliWidget_1.AwliWidget, { key: 0, enabled: $this.state.viewModel.awliEnabled, apiKey: $this.state.viewModel.awliApiKey, buttonMode: "BUTTON_DATA", integrationContext: $this.state.viewModel.awliIntegrationContext })] }), service_handler(), React.createElement(GridCol_1.GridCol, { key: 2, width: "12", children: [React.createElement(Text_1.Text, { key: 0, color: "Error", text: $this.state.viewModel.errorMessage, tag: "applyWith_errorMessage" })] })] })];
        };
        return (React.createElement("div", { className: "p-view-applywithbuttons" }, this.state.isInit ? root_handler() : null));
    };
    ApplyWithButtons.defaultProps = {
        services: "", errorMessage: "", applyWithButtonLabel: "",
        onClick: function () { }
    };
    return ApplyWithButtons;
}(React.Component));
exports.ApplyWithButtons = ApplyWithButtons;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplyWithButtons"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplyWithButtons/ApplyWithButtons.js
// module id = 585
// module chunks = 0